




























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import flvjs from "flv.js";
import { getPullUrl } from "@/req/boxLive/liveBroadRoom";
import ControlBar from "./components/ControlBar.vue";

@Component({
  components: { ControlBar },
})
export default class Home extends Vue {
  /**
   * @param {string} liveId 直播id
   * @param {string} url 直播地址
   * @param {number} type 0首页banner进入，1正常
   * @param {number} isMute 禁言时间
   * @param {object} detail 直播间详情
   */
  @Prop({ type: String, default: "" }) public liveId;
  @Prop({ type: String, default: "" }) public url;
  @Prop({ type: Number, default: 1 }) public type;
  @Prop({ type: Number, default: 0 }) public isMute;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public detail;
  @Prop({ type: Number, default: 0 }) public isFromCompetition;
  /**
   * @variable {any} flvPlayer 播放器
   * @variable {boolean} showBaberrage 弹幕组件显示
   * @variable {boolean} muted 是否静音
   */
  public flvPlayer: any = null;
  public showBaberrage = true;
  public muted = false;
  public isFullScreen = false;
  /**
   * @desc baberrageList 弹幕组件设置
   * @property {boolean} barrageIsShow 是否展示弹幕
   * @property {number} messageHeight 消息高度(测试不生效)
   * @property {boolean} barrageLoop 是否循环播放
   * @property {number} maxWordCount 弹幕字数(测试不生效)
   * @property {number} lanesCount 固定弹幕(测试不生效)
   * @property {number} boxWidth 弹幕宽度
   * @property {number} boxHeight 弹幕高度(测试不生效)
   * @property {number} throttleGap 消息间隔
   * @property {array} barrageList 弹幕列表
   */
  public baberrageList: any = {
    barrageIsShow: true,
    messageHeight: 3,
    barrageLoop: false,
    maxWordCount: 2,
    lanesCount: 2,
    boxWidth: 750,
    boxHeight: 100,
    throttleGap: 500,
    barrageList: [],
  };
  public arrI = 0;

  public mounted() {
    if (this.$route.query.muted && this.$route.query.muted == "1") {
      this.muted = true;
      this.flvPlayer.volume = 0;
    }
    this.setVideo(this.url);
  }

  @Watch("url", { deep: true })
  public urlChange(e) {
    if (this.url) {
      this.setVideo(this.url);
    }
  }

  public setVideo(urls) {
    if (flvjs.isSupported()) {
      const videoElement: any = document.getElementById("videoElement");
      const MediaDataSource: any = {
        type: "flv",
        isLive: true,
        url: urls || this.url,
        cors: true,
        hasAudio: true,
        hasVideo: true,
        segments: [],
        withCredentials: false,
        autoplay: true,
      };
      const obj = {
        cors: true,
        duration: undefined,
        filesize: undefined,
        timestampBase: 0,
        url: urls || this.url,
      };
      MediaDataSource.segments.push(obj);
      if (typeof this.flvPlayer !== "undefined") {
        if (this.flvPlayer != null) {
          this.flvPlayer.unload();
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
          this.flvPlayer = null;
        }
      }
      this.flvPlayer = flvjs.createPlayer(MediaDataSource, {
        enableWorker: false,
        lazyLoadMaxDuration: 3 * 60,
        seekType: "range",
      });
      this.flvPlayer.attachMediaElement(videoElement);
      this.flvPlayer.load();
      this.flvPlayer.play();
      videoElement.addEventListener("play", () => {
        // 播放开始执行的函数
        this.flvPlayer.volume = 0.5;
      });
    }
  }
  // 控制器设置
  public setConfig(func: string, param: any) {
    this[func](param);
  }
  // 开启暂停直播
  public setLivePlay(param) {
    param.isPause ? this.flvPlayer.pause() : this.flvPlayer.play();
  }
  // 重新加载
  public setReload() {
    this.$emit("reloadVideo");
    this.flvPlayer.play();
  }
  // 切换清晰度
  public async setArticulation(param) {
    const res = await getPullUrl({
      live_no: this.liveId,
      clarity: param.articulation,
    });
    if (res.code == 200) {
      this.setVideo(res.data.pull_url_flv);
    }
  }
  // 设置音量
  public setLiveMuted(param) {
    this.muted = false;
    this.flvPlayer.volume = param.volume;
  }
  // 设置全屏
  public setFullScreen(param) {
    this.showBaberrage = false;
    setTimeout(() => {
      this.showBaberrage = true;
    }, 10);
    this.isFullScreen = param.isFullScreen;
    if (param.isFullScreen) {
      this.baberrageList.boxWidth = 1920;
      const element: any = this.$refs.livevideobox;
      if (element.requestFullScreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      }
    } else {
      this.baberrageList.boxWidth = 750;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      } else if ((document as any).mozCancelFullScreen) {
        (document as any).mozCancelFullScreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      }
    }
  }
  // 销毁
  public beforeDestroy() {
    this.flvPlayer.pause();
    this.flvPlayer.unload();
    this.flvPlayer.detachMediaElement();
    this.flvPlayer.destroy();
    this.flvPlayer = null;
  }
}
